import { useCallback } from "react";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useEncodeBinaryForDeveloper = () => {
  const { handle } = useMessageHandler();

  const encode = useCallback(async (data: string): Promise<Blob | null> => {
    return await handle(async () => {
      const response = await apiJson.post("/binary/encode", data, {
        responseType: "blob",
      });
      return response.data as Blob;
    }).catch(() => null);
  }, [handle]);

  return { encode };
};
